import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable, tap } from 'rxjs';
import { User } from 'src/app/core/interfaces';
import { HttpService } from 'src/app/core/services/http.service';
import { ConfigService } from 'src/app/core/services/config.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userInfo: User;

  constructor(
    private httpService: HttpService,
    private storageService: StorageService,
    private router: Router,
    private configService: ConfigService,
    private translateService: TranslateService,
  ) {}

  login(loginData: any): Observable<any> {
    return this.httpService
      .serviceCall('get', `${environment.baseApiUrlV2}authentication/email/login?email=${loginData.email}&password=${loginData.password}`)
      .pipe(
        tap((loginRes: any) => {
          if (loginRes.Data) {
            this.userInfo = loginRes.Data;

            this.storageService.Set('cropmap_token', loginRes.Data.AuthToken);
            this.storageService.Set('token', loginRes.Data.Token);
            this.storageService.Set('cropmap_userInfo', loginRes.Data);
            return loginRes;
          } else {
            // If no data, return an empty observable
            return {
              Data: null,
              Message: this.translateService.instant('login.password-or-email-is-not-correct'),
            };
          }
        }),
      );
  }

  logOut() {
    let rememberMe = this.storageService.Get('rememberMe');
    let lang = this.storageService.Get('lang');
    this.userInfo = null;
    this.configService.resetAll();
    this.storageService.Clear();
    this.configService.enterpriseConfig = null;
    if (rememberMe) {
      this.storageService.Set('rememberMe', rememberMe);
    }
    this.storageService.Set('lang', lang);
    // this.httpService.openLink(environment.demoUrl,"_self");
    // this.mapService.removeCache();
    this.router.navigateByUrl('/auth/login');
  }

  resetPasswordEmail(email: any): Observable<any> {
    return this.httpService.serviceCall('get', environment.baseApiUrlV2 + 'user/forgot/password/send/email?email=' + email).pipe(
      map((res) => {
        if (res?.IsSuccess) {
          return res.Data;
        } else {
          return false;
        }
      }),
    );
  }

  changePassword(oldPwd: string, newPwd: string): Observable<any> {
    return this.httpService.serviceCall('post', environment.baseApiUrl + 'user/change/password', { oldPassword: oldPwd, newPassword: newPwd });
  }

  createNewPassword(data: any): Observable<any> {
    return this.httpService.serviceCall('post', environment.baseApiUrlV2 + 'user/forgot/password/handle/mail', data);
  }

  isExpireMail(token: string): Observable<any> {
    return this.httpService.serviceCall('get', environment.baseApiUrlV2 + 'user/forgot/password/check/expire/date?expire=' + token);
  }
}
